import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import Fail from '@/assets/icons/fail.svg';
import CheckIcon from '@/assets/icons/check.svg';
import IconCopy from '@/assets/icons/icon-copy.svg';

export const FailIcon = styled.div`
  background-image: url(${Fail});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;

  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -40%);

  .heading-1 {
    font-size: 28px !important;
  }

  .heading-1,
  .heading-2 {
    white-space: pre;
  }
`;

export const CenterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 60px 24px 0;
`;

export const ReasonBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: auto 5px;
  margin-bottom: 60px;
`;

export const FailButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const CTAwrapper = styled.section`
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const OrderHistoryButton = styled.button`
  flex: 1;
  height: 60px;
  border-radius: 8px;
  background-color: #ffe8de;
  color: #ff5c1a;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  line-height: 1.375;
`;

export const MarketHomeButton = styled.button`
  flex: 1;
  height: 60px;
  border-radius: 8px;
  background-color: #ff5b1a;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  line-height: 1.375;
`;

export const BannerWrapper = styled.div`
  margin-top: 8px;
`;

export const OrderNumberBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 14px;
  background-color: ${colors.gray100};
  border-radius: 5px;
  color: ${colors.gray700};
  font-weight: 700;
  margin-bottom: 20px;
`;

export const OrderStatusIcon = styled.div`
  background-image: url(${CheckIcon});
  background-color: var(--color-ui-primary-orange);
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  background-size: cover;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;

export const OrderInfo = styled.ul`
  width: 100%;
  padding: 30px 0;
  margin: 0 24px;
`;

export const DepositInfoLineContainer = styled.li`
  display: flex;
  justify-content: space-between;
`;

export const DepositInfoLineContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
`;

export const ButtonCopy = styled.div`
  width: 12px;
  height: 18px;
  background-image: url(${IconCopy});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`;
